import React from "react";

const HowItWorks = () => {
  return <h1>How it works</h1>;
};

export default HowItWorks;
